var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoRole(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 80,
    viewBox: "0 0 85 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.7609 63.3141L73.5963 62.259L18.1663 30.2637L16.3309 31.3221L71.7609 63.3141Z",
    fill: "url(#paint0_linear_4566_378099)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5963 78.945V62.2591L71.7609 63.3141V80L73.5963 78.945Z",
    fill: "url(#paint1_linear_4566_378099)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7609 80L16.3309 48.0047V31.3221L71.7609 63.3141V80Z",
    fill: "url(#paint2_linear_4566_378099)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2112 48.4033C26.2648 48.5037 26.3284 48.5908 26.3921 48.6746C26.5227 48.8588 26.6768 49.0061 26.8308 49.0932C27.0217 49.2037 27.2093 49.2305 27.3566 49.1468L31.2351 46.9497C31.5298 46.7822 31.5298 46.2397 31.2418 45.7339C30.9504 45.2282 30.4781 44.9535 30.1868 45.1177L26.8509 47.0066L25.7457 44.9535C25.471 44.4411 24.9954 44.1397 24.6907 44.2804C24.3825 44.421 24.3591 44.9535 24.6371 45.466L26.2179 48.3999L26.2112 48.4033Z",
    fill: "#8B8B8B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7715 65.8963L37.2503 51.1664C36.8383 50.9286 36.5034 51.1228 36.5034 51.5984C36.5034 52.074 36.8383 52.6534 37.2503 52.8912L62.7715 67.6212C63.1835 67.859 63.5184 67.6647 63.5184 67.1891C63.5184 66.7136 63.1835 66.1341 62.7715 65.8963Z",
    fill: "#8B8B8B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7676 33.0503L73.603 31.992L18.173 0L16.3376 1.05501L71.7676 33.0503Z",
    fill: "url(#paint3_linear_4566_378099)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5995 48.6779L73.6029 31.9919L71.7675 33.0503L71.7642 49.7362L73.5995 48.6779Z",
    fill: "url(#paint4_linear_4566_378099)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7642 49.7362L16.3342 17.7409L16.3376 1.05499L71.7675 33.0503L71.7642 49.7362Z",
    fill: "url(#paint5_linear_4566_378099)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2179 18.1395C26.2715 18.24 26.3351 18.327 26.3988 18.4108C26.5294 18.595 26.6835 18.7423 26.8375 18.8294C27.0284 18.9399 27.216 18.9667 27.3634 18.883L31.2418 16.6859C31.5365 16.5184 31.5365 15.9759 31.2485 15.4701C30.9571 14.9644 30.4849 14.6898 30.1935 14.8539L26.8576 16.7428L25.7524 14.6898C25.4777 14.1773 25.0021 13.8759 24.6974 14.0166C24.3892 14.1572 24.3658 14.6898 24.6438 15.2022L26.2246 18.1361L26.2179 18.1395Z",
    fill: "#8B8B8B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7748 35.6292L37.2536 20.8993C36.8416 20.6615 36.5067 20.8557 36.5067 21.3313C36.5067 21.8069 36.8416 22.3863 37.2536 22.6241L62.7748 37.3541C63.1868 37.5919 63.5217 37.3976 63.5217 36.9221C63.5217 36.4465 63.1868 35.867 62.7748 35.6292Z",
    fill: "#8B8B8B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4857 46.1224L68.3211 45.064L12.8912 13.0721L11.0558 14.1271L66.4857 46.1224Z",
    fill: "url(#paint6_linear_4566_378099)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3178 61.7499L68.3212 45.064L66.4858 46.1224L66.4824 62.805L68.3178 61.7499Z",
    fill: "url(#paint7_linear_4566_378099)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4824 62.7246L11.0525 30.7293L11.0558 14.0434L66.4858 46.0387L66.4824 62.7246Z",
    fill: "url(#paint8_linear_4566_378099)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9361 31.1279C20.9897 31.2284 21.0533 31.3154 21.1169 31.3992C21.2475 31.5834 21.4016 31.7307 21.5557 31.8178C21.7466 31.9283 21.9341 31.9551 22.0815 31.8714L25.9599 29.6743C26.2547 29.5068 26.2547 28.9643 25.9666 28.4585C25.6752 27.9528 25.203 27.6782 24.9116 27.8423L21.5758 29.7312L20.4705 27.6782C20.1959 27.1657 19.7203 26.8643 19.4155 27.005C19.1074 27.1456 19.0839 27.6782 19.3619 28.1906L20.9428 31.1245L20.9361 31.1279Z",
    fill: "#8B8B8B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4931 48.6176L31.9719 33.8876C31.5599 33.6498 31.225 33.8441 31.225 34.3197C31.225 34.7953 31.5599 35.3747 31.9719 35.6125L57.4931 50.3424C57.905 50.5802 58.24 50.386 58.24 49.9104C58.24 49.4348 57.905 48.8554 57.4931 48.6176Z",
    fill: "#8B8B8B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0558 14.0434L66.4857 46.0387",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3376 1.05499L71.7676 33.0503",
    stroke: "#F3F3F3",
    strokeWidth: 0.75
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4566_378099",
    x1: 44.5048,
    y1: 47.586,
    x2: 45.4258,
    y2: 45.9918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4566_378099",
    x1: 71.7609,
    y1: 71.1279,
    x2: 73.5963,
    y2: 71.1279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4A4A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4566_378099",
    x1: 16.3309,
    y1: 55.6611,
    x2: 71.7609,
    y2: 55.6611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4A4A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4566_378099",
    x1: 44.5081,
    y1: 17.3223,
    x2: 45.4292,
    y2: 15.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4566_378099",
    x1: 71.7642,
    y1: 40.8641,
    x2: 73.6029,
    y2: 40.8641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4A4A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4566_378099",
    x1: 16.3342,
    y1: 25.3973,
    x2: 71.7675,
    y2: 25.3973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4A4A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4566_378099",
    x1: 39.2263,
    y1: 30.391,
    x2: 40.1473,
    y2: 28.8001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4566_378099",
    x1: 66.4824,
    y1: 53.9362,
    x2: 68.3212,
    y2: 53.9362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4566_378099",
    x1: 11.0525,
    y1: 38.3823,
    x2: 66.4858,
    y2: 38.3823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBEBE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRole);
export default __webpack_public_path__ + "static/media/no_role.575d7e8638e8f58dff7ce807006ddc4e.svg";
export { ForwardRef as ReactComponent };